import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
export default {
    apiGetMyPackages: function() {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/subscription/me/packages';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },
    apiGetMyPackagesItem: function(campaignId) {
        let token = Account.getToken();
        let params = {
            campaignId: campaignId
        };
        let url = ConfigManager.getApiModuleUrl() + '/subscription/me/package';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    apiDeletePackage: function (campaignId) {
        let token = Account.getToken();
        let params = {
            campaignId: campaignId
        };
        let url = ConfigManager.getApiModuleUrl() + `/subscription/me/cancel`;
        return BzbsApi.connectBzbsDelete(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    apiGetSubscriptionItem: function(campaignId) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + `/subscription/${campaignId}/campaign`;
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },

    apiGetSubscriptionList: function() {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/subscription';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res.data.data;
        }));
    },

    apiGetSubscriptionDetail: function(campaignId,detailKey) {
        let token = Account.getToken();
        let params = {
            detailKey: detailKey,
        };
        let url = ConfigManager.getApiModuleUrl() + `/subscription/${campaignId}`;
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data.data;
        }));
    },

    apiRedeenSubscription: function(campaignId,detailKey) {
        let token = Account.getToken();
        let params = {
            detailKey: detailKey,
        };
        let url = ConfigManager.getApiModuleUrl() + `/subscription/${campaignId}/redeem`;
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    }
}